import { render, staticRenderFns } from "./UploadPhotoBox.vue?vue&type=template&id=684f6836&scoped=true"
import script from "./UploadPhotoBox.vue?vue&type=script&lang=js"
export * from "./UploadPhotoBox.vue?vue&type=script&lang=js"
import style0 from "./UploadPhotoBox.vue?vue&type=style&index=0&id=684f6836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f6836",
  null
  
)

export default component.exports